module.exports = __webpack_public_path__ + "static/media/resourcesExcercises.61c93172.png";